import { makeStyles } from '@mui/styles';

export const useStyle = makeStyles((theme) => ({
  content: {
    overflowY: 'auto'
  },

  userItem: {
    cursor: 'pointer'
  }
}));
